<template>
    <el-container>
        <el-aside class="app_aside">
            <div class="app_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <MyAside></MyAside>
        </el-aside>
        <el-container>
            <el-header>
                <MyHeader></MyHeader>
            </el-header>
            <div class="app_con">
                <div class="app_Rig app_RigW">
                    <div class="app_TNav">
                        <div class="app_TList">
                          <div class="app_TItem"
                               v-for="(todo, index) in todos"
                               :class="{ app_TAct: activeTabIndex === index }"
                               @click="switchTab(index)">
                            {{todo.title}} <i class="el-icon-close" @click.stop="removeTodo(index)" v-if="index>0"></i>
                          </div>
                        </div>
                    </div>
                    <el-main>
                        <div class="userBox">
                            <div class="userLBox">
                                <div class="userLogo">
                                  <el-upload class="avatar-uploader"
                                             action="/?a=add_file&action=ok&name=file" :show-file-list="false"
                                             :on-success="handleSuccesstx"
                                  >
                                    <img v-if="userForma.tx" :src="userForma.tx" class="avatar">
                                    <div v-else class="userPIcon">
                                      <i  class="el-icon-plus avatar-uploader-icon"></i>
                                      <span>上传证件照片</span>
                                    </div>
                                  </el-upload>
                                </div>
                                <div class="userName">
                                  {{userForma.name?userForma.name:'用户'+userForma.title}}
                                </div>
                                <div class="userList">
                                    <div class="userItem">
                                        <div class="userTit">
                                            联系手机:
                                        </div>
                                        <p> {{userForma.title}}</p>
                                    </div>
                                    <div class="userItem"  v-if="userpath==2">
                                        <div class="userTit">
                                            支付宝:
                                        </div>
                                        <p><span> {{userForma.zfb?userForm.zfb:'未绑定'}}</span></p>
                                    </div>
                                    <div class="userItem">
                                        <div class="userTit">
                                            实名认证:
                                        </div>
                                        <p v-if="userForma.isrz==2"><span style="color: #67c23a">已认证</span></p>
                                        <p v-if="userForma.isrz==1"><span>认证中</span></p>
                                        <p v-if="userForma.isrz==3"><span style="color: #ff0000">认证未通过</span></p>
                                        <p v-if="userForma.isrz==0"><span>未认证</span></p>
                                    </div>
                                    <div class="userItem">
                                        <div class="userTit">
                                            所属地区:
                                        </div>
                                        <p><span>{{userForma.add?userForm.add:'-'}}</span></p>
                                    </div>
                                    <div class="userItem">
                                        <div class="userTit">
                                            最近登录:
                                        </div>
                                        <p>{{userForma.lasttime}}</p>
                                    </div>
                                  <div class="userItem">
                                        <div class="userTit">
                                            推荐人:
                                        </div>
                                        <p>{{userForma.user}}</p>
                                    </div>
                                    <div class="userItem">
                                        <div class="userTit">
                                            邀请人数:
                                        </div>
                                        <p>{{userForma.cuser}}</p>
                                    </div>
                                    <div class="userItem">
                                        <div class="userTit">
                                            邀请码:
                                        </div>
                                        <p>{{userForma.yqm}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="userRBox">
                                <div class="userRTop">
                                    <el-tabs v-model="userName" @tab-click="handleClick">
                                        <el-tab-pane label="基本信息" name="Basic_information">
                                            <div class="userRList">
                                                <el-form ref="userForm" :model="userForm" label-width="100px" :rules="userRules">
                                                    <el-form-item label="账号:">
                                                        <div class="userZh">{{ userForm.title }} <span
                                                                @click="accountShow = true">更改绑定手机</span></div>
                                                    </el-form-item>
                                                    <el-form-item label="昵称:" prop="name">
                                                        <el-input v-model="userForm.name">
                                                            <i v-if="userForm.name" slot="suffix" class="el-icon-error el-icon-date"></i>
                                                        </el-input>
                                                    </el-form-item>
                                                    <el-form-item label="性别">
                                                        <el-radio-group v-model="userForm.sex">
                                                            <el-radio label="女"></el-radio>
                                                            <el-radio label="男"></el-radio>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                    <el-form-item label="微信号:" >
                                                        <el-input v-model="userForm.wx"
                                                            placeholder="微信号">
                                                        </el-input>
                                                    </el-form-item>
                                                    <el-form-item label="微信二维码:" prop="name">
                                                      <el-upload class="avatar-uploader"
                                                                 action="/?a=add_file&action=ok&name=file" :show-file-list="false"
                                                                 :on-success="handleSuccesswx"
                                                      >
                                                        <img v-if="userForm.yhjy" :src="userForm.yhjy" class="avatar">
                                                        <div v-else class="userPIcon">
                                                          <i  class="el-icon-plus avatar-uploader-icon"></i>
                                                          <span>上传微信二维码</span>
                                                        </div>
                                                      </el-upload>
                                                    </el-form-item>
                                                    <el-form-item label="出生日期:">
                                                        <el-date-picker v-model="userForm.sr" type="date"
                                                            placeholder="选择日期">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="邮箱:">
                                                        <el-input v-model="userForm.email" placeholder="请输入邮箱">
                                                        </el-input>
                                                    </el-form-item>
                                                    <template>
                                                    <el-form-item label="所在地:" class="userRDz" prop="location">
                                                      <el-select v-model="userForm.province" placeholder="请选择省份">
                                                        <el-option
                                                            v-for="province in provinces"
                                                            :key="province.value"
                                                            :label="province.label"
                                                            :value="province.value">
                                                        </el-option>
                                                      </el-select>
                                                      <el-select v-model="userForm.city" placeholder="请选择城市" v-if="userForm.province">
                                                        <el-option
                                                            v-for="city in cities[userForm.province]"
                                                            :key="city.value"
                                                            :label="city.label"
                                                            :value="city.value">
                                                        </el-option>
                                                      </el-select>
                                                    </el-form-item>
                                                  </template>
                                                    <el-form-item label="职业:" >
                                                        <el-select v-model="userForm.zy" placeholder="请选择职业">
                                                            <el-option label="学生" value="学生"> </el-option>
                                                            <el-option label="职场白领" value="职场白领"> </el-option>
                                                            <el-option label="宝妈" value="宝妈"> </el-option>
                                                            <el-option label="其他" value="其他"> </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-button class="userBtn" @click="updateuser">保存基本信息</el-button>
                                                </el-form>
                                            </div>
                                        </el-tab-pane>
                                        <el-tab-pane label="找回密码" name="Account_related">
                                          <div class="userRList">
                                            <el-form :model="MImaForm" label-width="100px">
                                              <el-form-item label="旧密码">
                                                <el-input v-model="MImaForm.jiu_password" placeholder="请输入旧密码"></el-input>
                                              </el-form-item>
                                              <el-form-item label="新密码">
                                                <el-input v-model="MImaForm.new_password" placeholder="请输入新密码"></el-input>
                                              </el-form-item>
                                              <el-form-item label="确定新密码">
                                                <el-input v-model="MImaForm.qnew_password" placeholder="请再次输入密码"></el-input>
                                              </el-form-item>
                                            </el-form>
                                            <div slot="footer" class="dialog-footer">
                                              <el-button type="primary" @click="MImaShowa">确 定</el-button>
                                            </div>
                                          </div>
                                        </el-tab-pane>
                                        <el-tab-pane label="绑定支付宝" name="Account_relateda" v-if="userpath==2">
                                           <div class="userRList" v-if="userForm.iszfb==0">
                                              <el-form :model="alipaytForm" label-width="100px">
                                                <el-form-item label="支付宝实名">
                                                  <el-input v-model="alipaytForm.alipayta" placeholder="请输入支付宝实名"></el-input>
                                                </el-form-item>
                                                <el-form-item label="支付宝号">
                                                  <el-input v-model="alipaytForm.alipayt" placeholder="请输入支付宝账号"></el-input>
                                                </el-form-item>
                                                <el-form-item label="手机验证码">
                                                  <el-input v-model="alipaytForm.Code" placeholder="请输入验证码"></el-input>
                                                  <div class="accountYz" @click="getyzmb()">{{ isCountingDownb ? '重新获取(' + countdownb + ')' : '获取验证码' }}</div>
                                                </el-form-item>
                                              </el-form>
                                              <div slot="footer" class="dialog-footer">
                                                <el-button type="primary" @click="alipaytShowa">确 定</el-button>
                                              </div>
                                            </div>
                                            <div class="userRList" v-else>
                                              <el-form :model="alipaytForm" label-width="100px">
                                                <el-form-item label="支付宝实名">
                                                  <el-input v-model="alipaytForm.alipayta" readonly placeholder="请输入支付宝实名"></el-input>
                                                </el-form-item>
                                                <el-form-item label="支付宝号">
                                                  <el-input v-model="alipaytForm.alipayt" readonly placeholder="请输入支付宝账号"></el-input>
                                                </el-form-item>
                                              </el-form>
                                            </div>
                                        </el-tab-pane>
                                        <el-tab-pane label="实名认证" name="authentication">
                                            <div class="userRList" v-if="userForm.isrz!=2">
                                                <el-form ref="nameForm" :model="userForm" label-width="100px"
                                                    :rules="nameRules">
                                                    <el-form-item label="客户花名:" prop="hm" v-if="userpath==1">
                                                        <el-input v-model="userForm.hm" placeholder="请输入姓名">
                                                        </el-input>
                                                    </el-form-item>
                                                    <el-form-item label="姓名:" prop="name">
                                                        <el-input v-model="userForm.xm" placeholder="请输入姓名">
                                                        </el-input>
                                                    </el-form-item>
                                                    <el-form-item label="证件类型:" prop="zjlx">
                                                        <el-select v-model="userForm.zjlx">
                                                            <el-option label="居民身份证" value="居民身份证"> </el-option>
                                                            <el-option label="临时身份证" value="临时身份证"> </el-option>
                                                            <el-option label="护照" value="护照"> </el-option>
                                                            <el-option label="港澳台居民来往内地通行证" value="港澳台居民来往内地通行证">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="证件号码:" prop="number">
                                                        <el-input v-model="userForm.number" placeholder="请输入证件号码">
                                                        </el-input>
                                                    </el-form-item>
                                                    <el-form-item label="证件照片:" prop="IDphoto">
                                                        <div class="userphoto" v-if="userForm.zjlx=='居民身份证'||userForm.zjlx=='临时身份证'">
                                                            <el-upload class="avatar-uploader"
                                                                       action="/?a=add_file&action=ok&name=file" :show-file-list="false"
                                                                       :on-success="handleSuccess">
                                                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                                                <div v-else class="userPIcon">
                                                                    <i  class="el-icon-plus avatar-uploader-icon"></i>
                                                                    <span>上传正面照</span>
                                                                </div>
                                                            </el-upload>
                                                            <el-upload class="avatar-uploader"
                                                                       action="/?a=add_file&action=ok&name=file" :show-file-list="false"
                                                                       :on-success="handleSuccessa">
                                                                <img v-if="imageUrla" :src="imageUrla" class="avatar">
                                                                <div v-else class="userPIcon">
                                                                    <i  class="el-icon-plus avatar-uploader-icon"></i>
                                                                    <span>背面证件照</span>
                                                                </div>
                                                            </el-upload>
                                                        </div>
                                                        <div class="userphoto" v-else>
                                                            <el-upload class="avatar-uploader"
                                                                action="/?a=add_file&action=ok&name=file" :show-file-list="false"
                                                                       :on-success="handleSuccess"
                                                                       >
                                                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                                                <div v-else class="userPIcon">
                                                                    <i  class="el-icon-plus avatar-uploader-icon"></i>
                                                                    <span>上传证件照片</span>
                                                                </div>
                                                            </el-upload>

                                                        </div>
                                                    </el-form-item>
                                                    <el-button class="userBtn" @click="smrz">保存认证信息 </el-button>
                                                </el-form>
                                            </div>
                                            <div class="userRList" v-if="userForm.isrz==2">
                                            <el-form ref="nameForm" :model="userForm" label-width="100px"
                                                     :rules="nameRules">
                                              <el-form-item label="客户花名:" prop="hm" v-if="userpath==1">
                                                <el-input v-model="userForm.hm" placeholder="请输入客户花名">
                                                </el-input>
                                              </el-form-item>
                                              <el-form-item label="姓名:" prop="name">
                                                <el-input v-model="userForm.xm" readonly  placeholder="请输入姓名">
                                                </el-input>
                                              </el-form-item>
                                              <el-form-item label="证件类型:" readonly  prop="zjlx">
                                                <el-select v-model="userForm.zjlx">
                                                  <el-option label="居民身份证" value="居民身份证"> </el-option>
                                                  <el-option label="临时身份证" value="临时身份证"> </el-option>
                                                  <el-option label="护照" value="护照"> </el-option>
                                                  <el-option label="港澳台居民来往内地通行证" value="港澳台居民来往内地通行证">
                                                  </el-option>
                                                </el-select>
                                              </el-form-item>
                                              <el-form-item label="证件号码:" readonly  prop="number">
                                                <el-input v-model="userForm.number" placeholder="请输入证件号码">
                                                </el-input>
                                              </el-form-item>
                                              <el-form-item label="证件照片:" prop="IDphoto">
                                                <div class="userphoto" v-if="userForm.zjlx=='居民身份证'||userForm.zjlx=='临时身份证'">
                                                  <el-upload class="avatar-uploader">
                                                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                                  </el-upload>
                                                  <el-upload class="avatar-uploader">
                                                    <img v-if="imageUrla" :src="imageUrla" class="avatar">
                                                  </el-upload>
                                                </div>
                                                <div class="userphoto" v-else>
                                                  <el-upload class="avatar-uploader">
                                                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                                  </el-upload>

                                                </div>
                                              </el-form-item>
                                            </el-form>
                                          </div>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                        </div>
                        <el-dialog title="更改绑定手机" class="Password" :visible.sync="accountShow">
                            <el-form :model="accountForm" label-width="130px">
                                <el-form-item label="当前手机号">
                                    <div class="accountNum">{{ userForm.title }}</div>
                                </el-form-item>
                                <el-form-item label="手机验证码">
                                    <el-input v-model="accountForm.yzm" autocomplete="off"></el-input>
                                    <div class="accountYz" @click="getyzm()">{{ isCountingDown ? '重新获取(' + countdown + ')' : '获取验证码' }}</div>
                                </el-form-item>
                                <el-form-item label="更改手机号">
                                    <el-input v-model="accountForm.tel" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="更改手机号验证码">
                                  <el-input v-model="accountForm.yzma" autocomplete="off"></el-input>
                                  <div class="accountYz" @click="getyzma()">{{ isCountingDowna ? '重新获取(' + countdowna + ')' : '获取验证码' }}</div>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="accountShow = false;accountForm=[]" class="Password_hide">取 消</el-button>
                                <el-button type="primary" @click="accountForma">确 定</el-button>
                            </div>
                        </el-dialog>


                    </el-main>
                </div>
            </div>
        </el-container>
    </el-container>
</template>

<script>
import axios from "axios";

export default {
    // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
    // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
    name: 'usercenter',
    data() {
        return {
            userName: 'Basic_information',
            // 修改密码
            MImaShow:false,
            MImaForm:{},
            // 绑定支付宝
            alipaytForm:{
              alipayt:'',
              alipayta:'',
            },
            alipaytShow:false,
            // 实名认证
            nameForm: {
                types: '',
                name: '',
                IDtype: '',
                IDphoto: '',
                IDNo: ''
            },
            nameRules: {
                types: [
                    { required: true, message: '请选择认证类型', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '姓名', trigger: 'blur' }
                ],
                zjlx: [
                    { required: true, message: '请选择证件类型', trigger: 'change' }
                ],
              number: [
                    { required: true, message: '身份证号码', trigger: 'blur' }
                ],
                IDphoto: [
                    { required: true, message: '请上传证件照片', trigger: 'change' }
                ],
            },
            // 基本信息
            userForm: {},
            userForma: {},
            userRules:{
                location1: [
                    { required: true, message: '请选择地区', trigger: 'change' }
                ],
                career: [
                    { required: true, message: '请选择认证类型', trigger: 'change' }
                ],
                location2: [
                    { required: true, message: '请选择认证类型', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '姓名', trigger: 'blur' }
                ],
            },
            // 修改手机号
            accountShow: false,
            accountForm: {
                newpassword: '',
                password: ''
            },
          todos:[],
          provinces: [],
          cities: {},
          countdown: 60, // 倒计时初始值
          isCountingDown: false, // 是否正在倒计时
          countdowna: 60, // 倒计时初始值
          isCountingDowna: false, // 是否正在倒计时
          countdownb: 60, // 倒计时初始值
          isCountingDownb: false, // 是否正在倒计时
          imageUrl:'',
          imageUrla:'',
          wxpic:''
        }
    },
    // 这里为了测试被切换的组件去哪了

    mounted() {
      this.todos=this.$store.state.tags
      let todos= this.todos
      console.log(this.todos);
      let index =todos.findIndex(note => note.path === "usercenter");
      if(index>=0){
        this.activeTabIndex=index
      }else{
        const newNote = {
          title: "个人中心",
          path: 'usercenter'
        }
        this.$store.state.tags.push(newNote);
        this.activeTabIndex=this.todos.length - 1
      }
      this.userpath=this.$store.state.userpath
      this.fetchTableData();
    },
    methods: {

      handleSuccess(response, file, fileList) {
        console.log(fileList)
        console.log(this.fileList)
        console.log('success', response, file, fileList);
        this.imageUrl=response.pica;
        this.userForm.zjpica=response.pica;
      },
      handleSuccesswx(response, file, fileList) {
        console.log(fileList)
        console.log(this.fileList)
        console.log('success', response, file, fileList);

        this.userForm.yhjy=response.pica;
      },
      handleSuccessa(response, file, fileList) {
        console.log(fileList)
        console.log(this.fileList)
        console.log('success', response, file, fileList);
        this.imageUrla=response.pica;
        this.userForm.zjpicb=response.pica;

      },
      handleSuccesstx(response, file, fileList) {
        this.userForma.tx=response.pica;
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=tx',{
          'title':this.userForma.tx,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(response => {
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
        // handleClick(tab, event) {
        //     console.log(tab, event);
        // },
      switchTab(index) {
        this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
      },
      removeTodo(index) {
        this.todos.splice(index, 1);
        this.$forceUpdate();
        if(index==this.activeTabIndex){
          this.$router.push(this.todos[index].path);
        }else if(index<this.activeTabIndex){
          this.activeTabIndex=this.activeTabIndex-1
        }
      },
      getyzm() {
        if (!this.isCountingDown) {
          axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=getyzmc',{
            'title':this.userForm.title,
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
              .then(response => {
                if(response.data.status==1){
                  this.isCountingDown = true;
                  this.startCountdown();
                }else{
                  this.$message({
                    type: 'info',
                    message: response.data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        }
      },
      getyzma() {
        if (!this.isCountingDowna) {
          axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=getyzmc',{
            'title':this.accountForm.tel,
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
              .then(response => {
                if(response.data.status==1){
                  this.isCountingDowna = true;
                  this.startCountdowna();
                }else{
                  this.$message({
                    type: 'info',
                    message: response.data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        }
      },
      getyzmb() {
        if (!this.isCountingDownb) {
          axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=getyzmb',{
            'title':this.alipaytForm.alipayt,
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
              .then(response => {
                if(response.data.status==1){
                  this.isCountingDownb = true;
                  this.startCountdownb();
                }else{
                  this.$message({
                    type: 'info',
                    message: response.data.msg
                  });
                }
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });
        }
      },
      startCountdown() {
        const interval = setInterval(() => {
          if (this.countdown <= 1) {
            clearInterval(interval);
            this.countdown = 60; // 重置倒计时
            this.isCountingDown = false; // 允许重新点击
          } else {
            this.countdown--;
          }
        }, 1000);
      },
      startCountdowna() {
        const interval = setInterval(() => {
          if (this.countdowna <= 1) {
            clearInterval(interval);
            this.countdowna = 60; // 重置倒计时
            this.isCountingDowna = false; // 允许重新点击
          } else {
            this.countdowna--;
          }
        }, 1000);
      },
      startCountdownb() {
        const interval = setInterval(() => {
          if (this.countdownb <= 1) {
            clearInterval(interval);
            this.countdownb = 60; // 重置倒计时
            this.isCountingDownb = false; // 允许重新点击
          } else {
            this.countdownb--;
          }
        }, 1000);
      },
      fetchTableData() {
        console.log(123)
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=user')
            .then(response => {
              this.userForm = response.data.arr;
              this.imageUrl = response.data.arr.zjpic[0];
              this.imageUrla = response.data.arr.zjpic[1];
              this.userForm.zjpica = response.data.arr.zjpic[0];
              this.userForm.zjpicb = response.data.arr.zjpic[1];
              this.userForma = response.data.arra;
              this.provinces = response.data.province;
              this.alipaytForm.alipayta = response.data.arr.djs;
              this.alipaytForm.alipayt = response.data.arr.zfb;
              this.cities = response.data.city;
              console.log(this.cities)
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });

      },
      updateuser(){
        const formData = {
          ...this.userForm // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=user', formData, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.userForm = response.data.arr;

                this.userForm.zjpica = response.data.arr.zjpic[0];
                this.userForm.zjpicb = response.data.arr.zjpic[1];
                this.imageUrl = response.data.arr.zjpic[0];
                this.imageUrla = response.data.arr.zjpic[1];
                this.userForma = response.data.arra;
                this.alipaytForm.alipayta = response.data.arr.djs;
                this.alipaytForm.alipayt = response.data.arr.zfb;
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      accountForma(){
        const formData = {
          ...this.accountForm // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=usertel', formData, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.accountShow = false;
                this.accountForm=[]
                this.userForm = response.data.arr;

                this.userForm.zjpica = response.data.arr.zjpic[0];
                this.userForm.zjpicb = response.data.arr.zjpic[1];
                this.imageUrl = response.data.arr.zjpic[0];
                this.imageUrla = response.data.arr.zjpic[1];
                this.userForma = response.data.arra;
                this.alipaytForm.alipayta = response.data.arr.djs;
                this.alipaytForm.alipayt = response.data.arr.zfb;
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      MImaShowa(){
        const formData = {
          ...this.MImaForm // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=userpwd', formData, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.MImaShow = false;
                this.MImaForm=[]
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      alipaytShowa(){
        const formData = {
          ...this.alipaytForm // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=userzfb', formData, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.alipaytShow = false;
                this.alipaytForm=[]
                this.userForm = response.data.arr;

                this.userForm.zjpica = response.data.arr.zjpic[0];
                this.userForm.zjpicb = response.data.arr.zjpic[1];
                this.imageUrl = response.data.arr.zjpic[0];
                this.imageUrla = response.data.arr.zjpic[1];
                this.userForma = response.data.arra;
                this.alipaytForm.alipayta = response.data.arr.djs;
                this.alipaytForm.alipayt = response.data.arr.zfb;
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      smrz(){
        const formData = {
          ...this.userForm // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=usersm', formData, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
                this.userForm = response.data.arr;

                this.userForm.zjpica = response.data.arr.zjpic[0];
                this.userForm.zjpicb = response.data.arr.zjpic[1];
                this.imageUrl = response.data.arr.zjpic[0];
                this.imageUrla = response.data.arr.zjpic[1];
                this.userForma = response.data.arra;
                this.alipaytForm.alipayta = response.data.arr.djs;
                this.alipaytForm.alipayt = response.data.arr.zfb;
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      }
    },
}
</script>

<style>
.userBox {
    display: flex;
    justify-content: space-between;
}

.userLBox {
    width: 40%;
    padding: 50px;
    background: #fff;
    border-radius: 16px;
}

.userLogo {
    width: 90px;
    height: 90px;
    margin: 0 auto;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, .1);
    overflow: hidden;
}

.userLogo * {
    width: 100%;
    height: 100%;
}
.userLogo .avatar-uploader .el-upload{
    width: 100%;
    height: 100%;
    border: none;
}

.userName {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-top: 20px;
}

.userList {
    margin-top: 30px;
}

.userItem {
    padding: 18px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f1f2f3;
}

.userTit {
    width: 80px;
    font-size: 16px;
    text-align: end;
}

.userItem p {
    font-size: 16px;
    width: calc(100% - 120px);
    text-align: end;
}

.userItem span {
    color: #ff5000;
}

.userRBox {
    width: calc(60% - 20px);
    background: #fff;
    border-radius: 16px;
}

.userRTit {
    font-size: 20px;
    padding: 20px;
    font-weight: 600;
}

.userRList {
    padding: 30px 50px;
}

.userRList .el-input__inner {
    border: 1px solid rgba(0, 0, 0, .1) !important;
    width: 100% !important;
}

.userRList .el-input {
    width: 100% !important;
}

.userRList .el-input__icon {
    color: #aaa;
}

.userRList .el-input__prefix {
    height: 100%;
    left: auto;
    transition: all .3s;
    right: 5px;
}

.userRList .el-input--prefix .el-input__inner {
    padding-left: 15px;
}

.userRList .el-input__suffix {
    right: 10px;
}

.userRList .el-input__suffix i {
    color: #999;
}

.userRList .el-select:hover .el-input__inner {
    border: 1px solid #f1f2f3 !important;
}

.userRList .el-radio-group {
    margin-left: 20px;
}

.userZh {
    font-size: 16px;
}

.userZh span {
    color: #ff5000;
    margin-left: 10px;
    cursor: pointer;
}

.userBtn {
    width: 200px;
    margin: 30px 0 0 100px !important;
    height: 50px;
    border-radius: 50px !important;
    background: #FF5000;
    color: #fff;
    font-size: 14px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    text-decoration: none;
}

.accountNum {
    font-size: 16px;
}

.accountYz {
    font-size: 13px;
    position: absolute;
    right: 10px;
    top: 0;
  cursor: pointer;
}

.userRDz .el-form-item__content {
    display: flex;
}

.userRDz .el-select {
    width: 45%;
    margin-right: 2%;
}

.userRTop {
    position: relative;
}

.userRTop .el-tabs__item {
    padding: 20px;
    height: auto;
    line-height: 1;
    font-size: 16px;
}

.userRTop .el-tabs__nav-wrap {
    padding: 0 20px;
}
.userphoto{
    display: flex;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #ff5000;
  }
  .userPIcon{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    width: 100%;
  }
  .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    text-align: center;
  }
  .userPIcon span{
    display: block;
    line-height: 1;
    font-size: 14px;
    color: #8c939d;
  }
  .userphoto .avatar-uploader{
    margin-right: 10px;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }
  .userRTop .el-tabs__item:hover{
    color: #ff5000;
  }
  .userRTop .el-tabs__item.is-active {
    color: #ff5000;
}
.userRTop .el-tabs__active-bar{
    background: #ff5000;
}


.userXItem{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f1f2f3;
    padding: 20px 0;
}
.userXLeft{
    display: flex;
    align-items: center;
}
.userXIcon{
    width: 35px;
    height: 35px;
    margin-right: 10px;
}
.userXIcon svg{
    width: 100%;
    height: 100%;
}
.userXText{
    position: relative;
  
}
.userXText p{
    font-size: 16px;
}
.userXBtn{
    color: #FF5000;
    cursor: pointer;
}
.Password .el-dialog__body{
    padding: 30px 40px;
}
</style>